module.exports = __webpack_public_path__ + "img/WebCrawlerEM.1d79859d.svg";